/** @format */

import $ from "jquery";
import axios from "axios";
import React, { useEffect, useState } from "react";

import Minimap from "../../../../../components/map/Minimap";
import { header } from "../../../../../components/api/Header";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

function Page4({ date }) {
  const [sts, setSts] = useState([]);
  const [zoom, setZoom] = useState(6);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [location, setLocation] = useState([
    41.03261314166325, 64.28638866665023,
  ]);

  useEffect(() => {
    const fetchSts = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/sirdaryo/stations?date=" +
            date,
          header()
        );
        setSts(res.data);
      } catch (e) {
        console.log("Xato", e);
      } finally {
        setLoading(false);
      }
    };
    fetchSts();
  }, [date]);

  const filterList = (text) => {
    $("#StsList li").each(function () {
      if ($(this)[0].innerText.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  return (
    <div className='details-box'>
      {loading ? (
        <LoadingCard loading={loading} heightSize={"80vh"} />
      ) : (
        <div className='details-box-left'>
          <div className='mb-2'>
            <input
              type='text'
              placeholder='Kuzatuv stansiyasi'
              className='form-control'
              onChange={(e) => filterList(e.target.value)}
            />
          </div>

          <ul style={{ maxHeight: "75vh", overflow: "auto" }} id='StsList'>
            {sts
              ? sts.map((s, i) => {
                  return (
                    <li
                      key={i}
                      className={s.lat && s.lan ? "haslatlng" : ""}
                      onClick={() => {
                        setZoom(13);
                        setLocation([s.lat, s.lan]);
                        setSelectedData(s);
                      }}>
                      <button
                        style={{
                          background:
                            selectedData?.id === s.id ? "#0b4aa9" : "",
                          color: selectedData?.id === s.id ? "#fff" : "",
                        }}
                        className='sidebar-list'>
                        <table>
                          <tbody>
                            <tr>
                              <td>{s.nomi}</td>
                              <td>{s.data}</td>
                              <td
                                style={{
                                  color:
                                    selectedData?.id === s.id
                                      ? "#fff"
                                      : "#0b4aa9",
                                }}>
                                {s.birligi}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </button>
                    </li>
                  );
                })
              : null}
          </ul>
        </div>
      )}
      <div className='details-box-right'>
        <Minimap
          zoom={zoom}
          locations={sts}
          location={location}
          onSelectData={(data) => {
            setSelectedData(data);
            setZoom(13);
            setLocation([data.lat, data.lan]);
          }}
        />
      </div>
    </div>
  );
}

export default Page4;
